module.exports = "/_next/static/images/401be4b9e0634a186209722f0655c216-hero-large.jpg.webp";